import { Eye, Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { CompanyRow } from "../types/companyListView.types";

interface CompanyRowActionsProps {
  row: CompanyRow;
  onView: (row: CompanyRow) => void;
  onEdit: (row: CompanyRow) => void;
  onDelete: (row: CompanyRow) => void;
}

const actionButtonClass = "tw-h-8 tw-w-8";

/** View / edit / delete icon actions for one grid row, styled after `ProductRowActions`. */
const CompanyRowActions = ({ row, onView, onEdit, onDelete }: CompanyRowActionsProps) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="View"
        onClick={() => onView(row)}
      >
        <Eye className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="Edit"
        onClick={() => onEdit(row)}
      >
        <Pencil className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={`${actionButtonClass} tw-text-destructive hover:tw-text-destructive`}
        title="Delete"
        onClick={() => onDelete(row)}
      >
        <Trash2 className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  );
};

export default CompanyRowActions;
